export const PublicOptions = [
  {
    label: 'Inicio',
    link: '/',
  },
  {
    label: 'Registro de asistencia',
    link: '/register',
  },
  {
    label: 'Ponentes',
    link: '/speakers',
  },
  {
    label: 'Programa',
    link: '/schedule',
  },
];
